const SvgHeatmap = props => (
  <svg width={24} height={24} viewBox='0 0 24 24' {...props}>
    <path d='M19 6.414L13.414 12 19 17.586V6.414zM17.586 5H6a1 1 0 00-1 1v11.586L17.586 5zM6.414 19h11.172L12 13.414 6.414 19zM6 3h12a3 3 0 013 3v12a3 3 0 01-3 3H6a3 3 0 01-3-3V6a3 3 0 013-3z' />
  </svg>
);

export default SvgHeatmap;
